import moment from 'moment';
import { Customer } from 'store/customers/customer';
import { NewShipmentFormFields } from './types';
import { createShipment } from 'store/declarations/client';
import { shipmentFormValidationSchema } from './validationSchemas';

export const ETA_FORMAT = 'MMMM D; HH:mm A';

export const getCustomerFieldText = (customer: Customer) => `${customer.name} (EORI: ${customer?.eori ?? 'none'})`;

export const submitShipmentForm = async (values: NewShipmentFormFields) => {
    await shipmentFormValidationSchema.validate(values, { abortEarly: false });

    const { carrier, countryOriginCode, entryCountryCode, destinationCode, eta } = values.shipmentDetails;

    return await createShipment({
        payload: {
            conflictsResolveMap: {},
            shipmentDetails: {
                carrier,
                countryOrigin: countryOriginCode,
                entryCountry: entryCountryCode,
                destination: destinationCode,
                eta: moment(eta).format('YYYY-MM-DD HH:mm'),
            },
        },
        params: {
            customerId: values.customer.customerId,
            jobId: values.shipment.shipmentId,
            s3Link: values.bulkSubmission.s3Link,
            templateId: values.template.templateId,
        },
    });
};
